import { Editor } from '@tiptap/core';

function setLink(editor: Editor) {
  const previousUrl = editor.getAttributes('link').href;
  const url = window.prompt('URL', previousUrl);

  // cancelled
  if (url === null) {
    return;
  }

  // update link
  editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
}

function unlink(editor: Editor) {
  editor.chain().focus().extendMarkRange('link').unsetLink().run();
}

export { setLink, unlink };
